export default {"src":"/_next/static/media/HR.5c181c9a.svg","height":18,"width":18};